import { z } from 'zod';

export const CapitalCallPropsSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  status: z.string().min(1, 'Status is required'),
  call_amount: z.number().positive(),
  call_date: z.string().date(),
  due_date: z.string().date(),
});

export type CapitalCallProps = z.infer<typeof CapitalCallPropsSchema>;
